export const ParkingReservationColumnKeys = {
	HUMAN_READABLE_ID: 'humanReadableId',
	CREATED_DATE: 'createdDate',
	CUSTOMER: 'customer',
	LOCATION: 'location',
	REGISTRATION: 'registration',
	START_DATE: 'startDate',
	END_DATE: 'endDate',
	TOTAL_PRICE: 'totalPrice',
	TRANSACTION_ID: 'transactionId',
	STATUS: 'status',
} as const;

export type ParkingReservationColumnKey =
	(typeof ParkingReservationColumnKeys)[keyof typeof ParkingReservationColumnKeys];
